import React from 'react'
import { IoIosArrowForward,IoIosArrowBack } from 'react-icons/io';
import "./button.scss"

const Button = ({
    children,
    id,
    onClick,
    type,
}) => {
  const ArrowIcons = id==="arrow-wrapper-left" ?IoIosArrowBack  :IoIosArrowForward ;
  return (
    //arrow-wrapper-right and arrow-wrapper-left both useing as a props 
    
    <button className="common-button" id={id} onClick={onClick} type={type}>
        {children}
        <div className='circle'>
        <ArrowIcons size={20}  className='left-arrow right-arrow'/>
        </div>
    </button>
  )
}

export default Button
